




















































































































































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { SwApp } from '@libs-uuif/shared/sw-app';
import { MswAppHeader } from '../msw-app-header';
import { MswAppNav } from '../msw-app-nav';
import { Getter, State, Mutation } from 'vuex-class';
import { MswPageTheme } from '@/shared/msw-types';
import { SwBlockingProgress } from '@libs-uuif/shared/sw-blocking-progress';
import { CoreStoreState, SetHelpContainerSlideVisiblePayload, SetHelpContentIdPayload, StorePageViewWidthPayload, SetSupportCasesSliderVisiblePayload } from '../core.store';
import { RootStoreState } from '@/store';
import { VuexMappedMutation } from '@libs-uuif/shared/common-types';
import MswStatusInfo from './components/status-info.vue';
import UUIFComponents from '@/shared/uuifComponent';
import MswAppFooter from '../msw-app-footer/msw-app-footer.vue';
// import { envCongif } from '@/shared/env.config';
import idb from '@/services/indexedDb.service';
// import { currentUserKey } from '@/shared/msw-constants';

// tslint:disable-next-line:no-unused
declare var feedbackWorkspace: Function;

@Component({
  components: {
    ...UUIFComponents,
    MswAppHeader,
    MswAppNav,
    MswAppFooter,
    SwApp,
    SwBlockingProgress,
    MswStatusInfo,
    // SwScrollView,
  },
})
export default class MswAppContentOpenRoute extends Vue {
  isShow:boolean = false;
  hideHeaderInSpog : boolean = true;
  removeMinCriteria : boolean = false;
  @Getter
  effectivePageTheme: MswPageTheme;
  @State((state: RootStoreState) => state.CoreStoreModule.loading)
  visible:boolean;

  @State((state: RootStoreState) => state.CoreStoreModule.hideNavToggle)
  hideNavToggle: CoreStoreState['hideNavToggle'];

  @Mutation
  readonly setHelpContainerSlideVisible: VuexMappedMutation<SetHelpContainerSlideVisiblePayload>;

  @Mutation
  readonly setSupportCaseSliderVisible: VuexMappedMutation<SetSupportCasesSliderVisiblePayload>;

  @Mutation
  setHelpContentId: VuexMappedMutation<SetHelpContentIdPayload>;

  @Mutation
  storePageViewWidth: VuexMappedMutation<StorePageViewWidthPayload>;

  @State((state:RootStoreState) => state.CoreStoreModule.selectedHelpId)
  selectedHelpId: CoreStoreState['selectedHelpId'];

  @Watch('selectedHelpId')
  private navDataUpdated() {
    if (this.$router.currentRoute.path.indexOf('dashboard') > -1
      || this.$router.currentRoute.path.indexOf('register-products') > -1
      || this.$router.currentRoute.path.indexOf('products') > -1
      || this.$router.currentRoute.path.indexOf('activitylogs') > -1
      || this.$router.currentRoute.path.indexOf('download-center') > -1
      || this.$router.currentRoute.path.indexOf('usage-report') > -1
      || this.$router.currentRoute.path.indexOf('mssp-tenant-mgmt') > -1
      || this.$router.currentRoute.path.indexOf('psa-integration') > -1
      || this.$router.currentRoute.path.indexOf('mssp-access-management') > -1
      || this.$router.currentRoute.path.indexOf('catalog') > -1) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  getWidth() {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth,
    );
  }

  mounted() {
    this.storePageViewWidth({ width:this.getWidth() });
    // this.isUserAuthorized();
    // this.dropOldUsersIdbs();
  }

  // dropOldUsersIdbs() {
  //   try {
  //     // @ts-ignore
  //     indexedDB.databases()
  //     .then((arr: any) => {
  //       arr.forEach((element: any) => {
  //         if (element.name !== this.$store.getters.getUserId) {
  //           indexedDB.deleteDatabase(element.name);
  //         }
  //       });
  //     });
  //   } catch (e) {
  //     const stores = localStorage.getItem('UnclearedIdbs');
  //     if (stores) {
  //       JSON.parse(stores)
  //       .forEach((store: string) => {
  //         if (store !== this.$store.getters.getUserId) {
  //           indexedDB.deleteDatabase(store);
  //         }
  //       });
  //     }
  //     if (isChrome) {
  //       console.warn(e);
  //     }
  //   }
  // }

  created() {
    if (window.location.href.indexOf('spog-homepage') > -1) {
      this.removeMinCriteria = true;
    }
    // const currentUser : any = localStorage.getItem(currentUserKey);
    if (true) {
      window.addEventListener('message', (e : Event) => {
        this.spogEventListner(e);
      });
    }
    const lsStores = localStorage.getItem('clearIdbStores');
    if (lsStores) {
      const stores: any[] = JSON.parse(lsStores);
      stores.forEach((store) => {
        idb.removeItem(store);
      });
    }
    localStorage.setItem('clearIdbStores', JSON.stringify([]));
    if (location.pathname.indexOf('feature/spog-homepage') > -1 || location.pathname.indexOf('feature/unified-insights') > -1) {
      this.hideHeaderInSpog = false;
    } else {
      this.hideHeaderInSpog = true;
    }
  }

  spogEventListner(event : any) {
    if (event.data.closeCurtain) {
      const curtainFrame = this.$refs.mswCurtainFrame as HTMLFrameElement;
      if (curtainFrame !== null) {
        curtainFrame.contentWindow!.postMessage({
          closedCurtain: true,
          service: event.data.service,
          navigateUrl: event.data.navigateUrl,
        },                                      '*');
      }
    }
  }
  // isUserAuthorized() {
  //   this.authorizedUser = JSON.parse(this.$store.getters.getUserInfo).user.roles
  //     .indexOf('WORKSPACEBETA') !== -1;
  //   if (!this.authorizedUser && window.location.href.indexOf('spog-homepage') > -1) {
  //     this.authorizedUser = JSON.parse(this.$store.getters.getUserInfo).user.roles
  //     .indexOf('SPOGREADONLY') !== -1;
  //   }
  // }
}
